import {
    all,
    put,
    race,
    SagaIterator,
    takeErrorRequest,
    takeEveryCompletedRequest,
    takeFatalErrorRequest,
    takeSuccessfulRequest
} from './core/sagaEffects';
import { PasswordCreateRequest, PasswordResetRequest, PasswordTokenRequest } from 'acscp/api/requests';
import { FetchRequest } from 'acscp/actions';
import history from 'acscp/store/history';
import { LoginPageVariant } from 'acscp/store/loginPageVariant';
import { defaultLoginUrlForVariant } from 'acscp/components/routeHelper';

export function* loginAfterPasswordResetSaga(): SagaIterator {
     yield all([
        takeEveryCompletedRequest(PasswordCreateRequest, loginAndRedirect),
        takeEveryCompletedRequest(PasswordResetRequest, loginAndRedirect),
    ]);
}

export function* loginAndRedirect(
    response: undefined,
    request: PasswordResetRequest | PasswordCreateRequest
): SagaIterator {
    const loginPageVariant = request instanceof PasswordCreateRequest && request.isLoyaltySchemeOnly
        ? LoginPageVariant.LoyaltyScheme
        : LoginPageVariant.JetPortal;

    const loginRequest = new PasswordTokenRequest(request.username, request.password, loginPageVariant);
    const fetchAction = new FetchRequest(loginRequest);

    yield put(fetchAction);

    // Rely on login page to handle any errors or redirect to root on success
    yield race({
        success: takeSuccessfulRequest(PasswordTokenRequest),
        error: takeErrorRequest(PasswordTokenRequest),
        fail: takeFatalErrorRequest(PasswordTokenRequest),
    });

    history.push(defaultLoginUrlForVariant(loginPageVariant));
}
